/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

export const OPTIONS_SITUATION_MATRIMONIALE: Record<
  'key' | 'text' | 'masculin' | 'feminin' | 'value',
  number | string | string | string | string
>[] = [
  {
    key: 1,
    text: 'Célibataire',
    masculin: 'Célibataire',
    feminin: 'Célibataire',
    value: 'celibataire',
  },
  {
    key: 2,
    text: 'Marié(e)',
    masculin: 'Marié',
    feminin: 'Mariée',
    value: 'marie',
  },
  {
    key: 3,
    text: 'Divorcé(e)',
    masculin: 'Divorcé',
    feminin: 'Divorcée',
    value: 'divorce',
  },
  {
    key: 4,
    text: 'Séparé(e) de corps',
    masculin: 'Séparé de corps',
    feminin: 'Séparée de corps',
    value: 'separe-de-corps',
  },
  {
    key: 5,
    text: 'Concubinage',
    masculin: 'Concubinage',
    feminin: 'Concubinage',
    value: 'concubinage',
  },
  {
    key: 6,
    text: 'Veuf(ve)',
    masculin: 'Veuf',
    feminin: 'Veuve',
    value: 'veuf',
  },
  {
    key: 7,
    text: 'Séparé(e) de fait',
    masculin: 'Séparé de fait',
    feminin: 'Séparée de fait',
    value: 'separe-de-fait',
  },
  {
    key: 8,
    text: 'Remarié(e)',
    masculin: 'Remarié',
    feminin: 'Remariée',
    value: 'remarie',
  },
  {
    key: 9,
    text: 'Pacte civil de solidarité',
    masculin: 'Pacte civil de solidarité',
    feminin: 'Pacte civil de solidarité',
    value: 'pacte-civil-de-solidarite',
  },
  {
    key: 10,
    text: 'Autre situation',
    masculin: 'Autre situation',
    feminin: 'Autre situation',
    value: 'autre-situation',
  },
];

export const OPTIONS_PUPILLE: Record<
  'key' | 'text' | 'value',
  number | string | string
>[] = [
  {
    key: 1,
    text: "de l'état",
    value: 'etat',
  },
  {
    key: 2,
    text: 'de la nation',
    value: 'nation',
  },
];
